export * from "@vaadin/avatar/vaadin-avatar.js";
export * from './generated/Avatar.js';
